<template>
  <div
    class="GuestbookPage"
    :style="{ 'background-color': guestbookBodyColor }"
  >
    <div v-if="!fetchingPageContent">
      <div
        class="content"
        v-html="this.contents[activeLanguageIndex]"
      ></div>
      <button
        class="backHomeButton"
        :style="{
          backgroundColor: pagesTitleColor,
          color: pagesButtonTextColor,
        }"
        @click="loadHomePage"
      >
        &lt; {{ activeLanguageIndex ? buttonTextSec : buttonText }}
      </button>
    </div>
  </div>
</template>
<script>
import cookieMixin from "@/mixins/cookieMixin";
import { db } from "@/firebase";
import { trackBehavior } from "../callables";
export default {
  mixins: [cookieMixin],
  props: {
    pageId: String,
    activeLanguageIndex: Number,
  },
  data() {
    return {
      guestbookBodyColor: "#FFFFFF",
      contents: "",
      pagesTitleColor: "",
      pagesButtonTextColor: "",
      buttonText: "",
      buttonTextSec: "",
      fetchingPageContent: true,
    };
  },
  created() {
    this.loadPageContent(this.pageId);
  },
  methods: {
    loadHomePage() {
      this.$emit("closeModal");
    },
    //uniquePageId
    loadPageContent(uniquePageId) {
      this.fetchingPageContent = true;
      let navigationData = db
        .ref(`/hotels/${this.$customerId}/${this.$hotelId}/nav`)
        .once("value")
        .then((dataSnap) => {
          this.pagesTitleColor = dataSnap.val().pagesTitleColor;
          this.pagesButtonTextColor = dataSnap.val().pagesButtonTextColor;
          this.guestbookBodyColor = dataSnap.val().guestbookBodyColor;
          this.buttonTextSec = dataSnap.val().pageButtonTextSec || "BACK HOME";
          this.buttonText = dataSnap.val().pageButtonText || "BACK HOME";
          return true;
        });

      let pageNamePromise = db
        .ref(`/pages/${this.$customerId}/${this.$hotelId}/overview/${uniquePageId}`)
        .once("value")
        .then((overviewSnap) => {
          var currentPageTitle = overviewSnap.val().name;
          var activeGuestTemp = sessionStorage.getItem("activeGuestTemp");
          activeGuestTemp = activeGuestTemp ? activeGuestTemp : "unknownID";

          trackBehavior({
            action: "view",
            page: currentPageTitle,
            guestID: activeGuestTemp,
            eventID: this.$hotelId,
            customerID: this.$customerId,
          });

          return true;
        });

      let hotelPageData = db
        .ref(`/pages/${this.$customerId}/${this.$hotelId}/${uniquePageId}`)
        .once("value")
        .then( snapshot => {
          this.contents = snapshot.val()
          return true;
        });

      Promise.all([navigationData, pageNamePromise, hotelPageData]).then(() => {
        this.fetchingPageContent = false;
      });
    },
  },
};
</script>
<style scoped>
.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: all 0.5s;
  opacity: 1;
}

.fadeIn-enter,
.fadeIn-leave-to {
  transition: all 0.5s;
  opacity: 0;
}

.GuestbookPage {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.content {
  background-color: #fff;
  padding: 0px;
  width: 1000px;
  height: auto;
  margin: 0 auto;
  margin-bottom: 10px;
  padding: 1px 20px 20px 20px;
}
p {
  border: 3px solid black;
}

.backHomeButton-wrapper {
  display: flex;
  width: 100%;
}

.backHomeButton {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  padding: 15px 30px;
  border: none;
  border-radius: 5px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

@media (max-width: 1000px) {
  .content {
    width: 100%;
    padding-top: 10px;
  }
}

/* Mobile */
@media (max-width: 450px) {
  #background {
    /* display: none; */
    position: relative;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: visible;
    -webkit-overflow-scrolling: touch;
    /* background: #F2F1E7; */
  }
}
</style>
